import React from "react";

import { TextElement } from "@/components/ui-kit/TextElement/TextElement";
import { useNavigation } from "@/hooks/useNavigation";
import { ContentfulProduct } from "@/types/common";
import { LinkedItem } from "@/types/search";

import LinkedItems from "./LinkedItems";
import styles from "./NoResults.module.scss";
import ProductList from "./ProductList";
import QuizCTA from "./QuizCTA";
import SearchResultsLayout from "./SearchResultsLayout";

export interface NoResultsProps {
  text: string;
  faq: LinkedItem[];
  pages?: LinkedItem[];
  category: ContentfulProduct[];
  onClick: (event: React.MouseEvent<HTMLButtonElement>, item: LinkedItem) => void;
}

/**
 * NoResults component displays message and suggestions when search yields no results
 */
const NoResults: React.FC<NoResultsProps> = ({ text, faq, pages, category, onClick }) => {
  const navigate = useNavigation();

  // Defensive sort for category; fallback empty array
  const sortedCategory = Array.isArray(category)
    ? category.sort((a, b) => a.orderQty - b.orderQty).slice(0, 4)
    : [];

  return (
    <div className="w-full h-full">
      <div className={styles.noResults}>
        <TextElement className="body--xlarge mb-1" text={`No results found for "${text}".`} />
        <TextElement
          className="body--large noResultsSubcopy"
          text="Try another search or select an option below."
        />
      </div>
      <SearchResultsLayout>
        <>
          <TextElement text="Popular Products" className="title--small" />
          <div className="mt-1 md:mt-4">
            <ProductList products={sortedCategory} />
          </div>
          <QuizCTA />
        </>
        <>
          <div className="mb-8">
            {faq.length > 0 && (
              <LinkedItems title="Frequently Asked Questions" items={[...faq]} onClick={onClick} />
            )}
          </div>
          <div>
            {pages?.length && pages.length > 0 && (
              <LinkedItems
                title="Resources"
                items={[...pages]}
                onClick={(e, item) => {
                  e.preventDefault();
                  navigate(item.path ?? "");
                }}
              />
            )}
          </div>
        </>
      </SearchResultsLayout>
    </div>
  );
};

export default NoResults;
